import { API_ERROR, SET_PREVIEW_CLIENT, SET_PREVIEW_CLIENT_SUCCESS } from "./actionTypes";

export const getClient = (params) => ({
  type: SET_PREVIEW_CLIENT,
  payload: params,
});

export const apiError = (error) => ({
  type: API_ERROR,
  payload: error,
});

export const getClientSuccess = (clientIdx) => {
  return {
    type: SET_PREVIEW_CLIENT_SUCCESS,
    payload: clientIdx,
  };
};
